export const FORM_SETTINGS = `
  formSettings {
    ... on formSettings_ContentBlock {
      heading
      formId
      redirectLocation {
        url
      }
      withBorder
      onlyBusinessEmail
      errorValidateBusinessEmail
    }
  }
`
